export const customFilter = {
    showFilter: true,
    maintenanceType: false,
    machine: false,
    deliveryDateFrom: false,
    deliveryDateTo: false,
    dateCreatedFrom: false,
    dateCreatedTo: false
}